import {
  LOG_IN,
  LOG_IN_FAILURE,
  LOG_IN_SUCCESS,
  LOG_OUT,
  SET_ROLE,
} from "./types";
// import { useNavigate } from "react-router-dom";

export const AuthInitialState = {
  email: "",
  token: "",
  role: localStorage.getItem("role") || "",
  loginFailure: null,
  refreshToken: "",
};

export interface IAuthState {
  email: string;
  token: string;
  role: string;
  refreshToken: string;
}

const reducer = (state = AuthInitialState, action: any = {}) => {
  switch (action.type) {
    case LOG_IN:
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("refreshToken", action.payload.refreshToken);
      return {
        ...state,
        // role:action.payload.role,
        token: action.payload.token,
        refreshToken: action.payload.refreshToken,
      };

    case LOG_IN_FAILURE: {
      return {
        ...state,
        loginFailure: action.loginFailure,
      };
    }

    case LOG_OUT:
      localStorage.removeItem("role");
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      return {
        ...state,
        role: "",
        token: "",
        refreshToken: "",
      };

    case SET_ROLE: {
      localStorage.setItem("role", action.role);
      return {
        ...state,
        role: action.role,
      };
    }

    default:
      return state;
  }
};

export default reducer;
